import { Component, OnInit, Renderer2, ViewChild, ElementRef, Directive, NgZone } from '@angular/core';
import { ROUTES } from '../.././topbar/topbar.component';
import { Router, ActivatedRoute, NavigationEnd, NavigationStart } from '@angular/router';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { Subscription } from 'rxjs/Subscription';
import { Utilitarios } from '../../_common/utilitarios.common';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { BehaviorSubject } from 'rxjs';

var misc: any = {
  navbar_menu_visible: 0,
  active_collapse: true,
  disabled_collapse_init: 0,
}

@Component({
  moduleId: module.id,
  selector: 'navbar-cmp',
  templateUrl: 'navbar.component.html'
})

export class NavbarComponent implements OnInit {
  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;
  title = 'angular-idle-timeout';

  private IdleTime: number = 1;
  private TimeOutLogout: number = 900;
  //private TimeOutLogout: number = 75;
  private MinutoFaltandoIdle: number;
  private SegundoFaltandoIdle: number;
  public TempoFaltandoIdle: string;

  private listTitles: any[];
  location: Location;
  private nativeElement: Node;
  private toggleButton;
  private sidebarVisible: boolean;
  private _router: Subscription;
  public open: boolean = false;

  @ViewChild("navbar-cmp", { static: false }) button;

  private readonly IDLE_LIMIT_MS = 15 * 60 * 1000; // 15 minutos
  private readonly CHECK_INTERVAL = 1000; // 1 segundo
  public remainingTime$ = new BehaviorSubject<number>(this.IDLE_LIMIT_MS);

  private countdownIntervalId: any;
  private checkIntervalId: any;

  public minutes: number = 0;
  public seconds: number = 0;


  constructor(location: Location, private renderer: Renderer2, private element: ElementRef, private router: Router, private idle: Idle, private ngZone: NgZone) {
    this.location = location;
    this.nativeElement = element.nativeElement;
    this.sidebarVisible = false;

    this.startWatching();

    this.remainingTime$.subscribe(ms => {
      this.minutes = Math.floor(ms / 60000);
      this.seconds = Math.floor((ms % 60000) / 1000);
    });
  }

  startWatching() {

    this.setActivity();
    this.startCountdownTimer();

    const events = ['mousemove', 'keydown', 'touchstart', 'scroll'];
    events.forEach(event => {
      window.addEventListener(event, this.setActivity.bind(this), true);
    });

    document.addEventListener('visibilitychange', this.handleVisibilityChange.bind(this));

    this.ngZone.runOutsideAngular(() => {
      this.checkIntervalId = setInterval(() => {
        this.checkIdleTime();
      }, this.CHECK_INTERVAL);
    });
  }

  private setActivity() {
    localStorage.setItem('lastActivity', Date.now().toString());
    this.remainingTime$.next(this.IDLE_LIMIT_MS);
  }

  private checkIdleTime() {
    const lastActivity = parseInt(localStorage.getItem('lastActivity') || '0', 10);
    const now = Date.now();

    if (now - lastActivity > this.IDLE_LIMIT_MS) {
      this.triggerLogout();
    }
  }

  private handleVisibilityChange() {
    if (!document.hidden) {
      this.checkIdleTime();
    }
  }

  private triggerLogout() {
    this.clearTimers();

    localStorage.removeItem('lastActivity');

    this.Logout();
  }

  private clearTimers() {
    if (this.checkIntervalId) {
      clearInterval(this.checkIntervalId);
    }

    if (this.countdownIntervalId) {
      clearInterval(this.countdownIntervalId);
    }
  }

  stopWatching() {
    this.clearTimers();

    const events = ['mousemove', 'keydown', 'touchstart', 'scroll'];

    events.forEach(event => {
      window.removeEventListener(event, this.setActivity.bind(this), true);
    });

    document.removeEventListener('visibilitychange', this.handleVisibilityChange.bind(this));
  }

  private startCountdownTimer() {
    this.ngZone.runOutsideAngular(() => {
      this.countdownIntervalId = setInterval(() => {
        const lastActivity = parseInt(localStorage.getItem('lastActivity') || '0', 10);
        const elapsed = Date.now() - lastActivity;
        const remaining = this.IDLE_LIMIT_MS - elapsed;

        this.ngZone.run(() => {
          this.remainingTime$.next(remaining > 0 ? remaining : 0);
        });

        if (remaining <= 0) {
          this.triggerLogout();
        }
      }, 1000);
    });
  }

  coutndownTimeToString() {
    this.SegundoFaltandoIdle--;

    let _minFaltandoString = this.MinutoFaltandoIdle.toString();
    let _segFaltandoString = this.SegundoFaltandoIdle.toString();

    if (this.SegundoFaltandoIdle == 0) {
      this.MinutoFaltandoIdle--;
      this.SegundoFaltandoIdle = 60;

      if (this.MinutoFaltandoIdle == 0) {
        this.MinutoFaltandoIdle = 15;
      }
    }

    if (this.MinutoFaltandoIdle < 10) {
      _minFaltandoString = "0" + this.MinutoFaltandoIdle.toString();
    }

    if (this.SegundoFaltandoIdle < 10) {
      _segFaltandoString = "0" + this.SegundoFaltandoIdle.toString();
    }

    this.TempoFaltandoIdle = _minFaltandoString + ":" + _segFaltandoString;
  }

  ngOnInit() {
    this.listTitles = ROUTES.filter(listTitle => listTitle);

    const navbar: HTMLElement = this.element.nativeElement;
    const body = document.getElementsByTagName('body')[0];

    body.classList.remove('sidebar-mini');

    this.toggleButton = navbar.getElementsByClassName('navbar-toggler')[0];

    this._router = this.router.events.filter(event => event instanceof NavigationEnd).subscribe((event: NavigationEnd) => {
      const $layer = document.getElementsByClassName('close-layer')[0];
      if ($layer) {
        $layer.remove();
      }
    });
  }

  //minimizeSidebar() {
  //  const body = document.getElementsByTagName('body')[0];
  //  let clsSidebarMini = body.classList.contains("sidebar-mini");

  //  if (clsSidebarMini) {
  //    body.classList.remove('sidebar-mini');
  //  }
  //  else {
  //    body.classList.add('sidebar-mini');
  //  }

  //  //if (misc.sidebar_mini_active === true) {
  //  //  body.classList.remove('sidebar-mini');
  //  //  misc.sidebar_mini_active = false;

  //  //} else {

  //  //  if (misc.sidebar_mini_active == undefined) {
  //  //    body.classList.remove('sidebar-mini');
  //  //    misc.sidebar_mini_active = false;
  //  //  }
  //  //  else {

  //  //    setTimeout(function () {
  //  //      if (!body.classList.contains("sidebar-mini")) {
  //  //        //body.classList.add('sidebar-mini');

  //  //        //misc.sidebar_mini_active = true;
  //  //      }
  //  //      body.classList.add('sidebar-mini');

  //  //      misc.sidebar_mini_active = true;
  //  //    }, 300);
  //  //  }
  //  //}

  //  // we simulate the window Resize so the charts will get updated in realtime.
  //  const simulateWindowResize = setInterval(function () {
  //    window.dispatchEvent(new Event('resize'));
  //  }, 180);

  //  // we stop the simulation of Window Resize after the animations are completed
  //  setTimeout(function () {
  //    clearInterval(simulateWindowResize);
  //  }, 1000);
  //}

  isMobileMenu() {
    if (window.outerWidth < 991) {
      return false;
    }
    return true;
  }

  sidebarOpen() {
    var toggleButton = this.toggleButton;
    var html = document.getElementsByTagName('html')[0];
    setTimeout(function () {
      toggleButton.classList.add('toggled');
    }, 500);
    const mainPanel = <HTMLElement>document.getElementsByClassName('main-panel')[0];
    if (window.innerWidth < 991) {
      mainPanel.style.position = 'fixed';
    }
    html.classList.add('nav-open');
    this.sidebarVisible = true;
  }

  sidebarClose() {
    var html = document.getElementsByTagName('html')[0];
    this.toggleButton.classList.remove('toggled');
    this.sidebarVisible = false;
    html.classList.remove('nav-open');
    const mainPanel = <HTMLElement>document.getElementsByClassName('main-panel')[0];

    if (window.innerWidth < 991) {
      setTimeout(function () {
        mainPanel.style.position = '';
      }, 500);
    }
  }

  sidebarToggle() {
    // var toggleButton = this.toggleButton;
    // var body = document.getElementsByTagName('body')[0];
    if (this.sidebarVisible == false) {
      this.sidebarOpen();
    } else {
      this.sidebarClose();
    }
  }

  getTitle() {
    var titlee = this.location.prepareExternalUrl(this.location.path());
    if (titlee.charAt(0) === '#') {
      titlee = titlee.slice(1);
    }
    for (var item = 0; item < this.listTitles.length; item++) {
      var parent = this.listTitles[item];
      if (parent.path === titlee) {
        return parent.title;
      } else if (parent.children) {
        var children_from_url = titlee.split("/")[2];
        for (var current = 0; current < parent.children.length; current++) {
          if (parent.children[current].path === children_from_url) {
            return parent.children[current].title;
          }
        }
      }
    }
    return 'Clientes';
  }

  getPath() {
    // console.log(this.location);
    return this.location.prepareExternalUrl(this.location.path());
  }

  Logout() {
    let _objUtilitarios = new Utilitarios();

    if (_objUtilitarios.VerificarLocalStorageAutenticacao()) {
      _objUtilitarios.RemoverItemLocalStorageAutenticacao();
    }

    if (Utilitarios.Roles.length > 0) {
      Utilitarios.Roles = [];
    }

    this.router.navigate(['/pages/login']);
  }

  ConfigurarIdle() {
    this.idle.setIdle(this.IdleTime);
    this.idle.setTimeout(this.TimeOutLogout);
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    this.idle.onIdleEnd.subscribe(() => {
      this.idleState = 'No longer idle.'

      this.reset();
    });

    this.idle.onTimeout.subscribe(() => {
      this.idleState = 'Timed out!';

      this.timedOut = true;
      this.Logout();
    });

    this.idle.onIdleStart.subscribe(() => {
      this.idleState = 'You\'ve gone idle!'
    });

    this.idle.onTimeoutWarning.subscribe((countdown) => {
      this.idleState = 'You will time out in ' + countdown + ' seconds!'

      this.SegundoFaltandoIdle--;

      let _minFaltandoString = this.MinutoFaltandoIdle.toString();
      let _segFaltandoString = this.SegundoFaltandoIdle.toString();

      if (this.SegundoFaltandoIdle == 0) {
        this.MinutoFaltandoIdle--;
        this.SegundoFaltandoIdle = 60;

        if (this.MinutoFaltandoIdle == 0) {
          this.MinutoFaltandoIdle = 15;
        }
      }

      if (this.MinutoFaltandoIdle < 10) {
        _minFaltandoString = "0" + this.MinutoFaltandoIdle.toString();
      }

      if (this.SegundoFaltandoIdle < 10) {
        _segFaltandoString = "0" + this.SegundoFaltandoIdle.toString();
      }

      this.TempoFaltandoIdle = _minFaltandoString + ":" + _segFaltandoString;
    });

    // sets the ping interval to 15 seconds
    //keepalive.interval(15);

    //keepalive.onPing.subscribe(() => this.lastPing = new Date());

    this.reset();
  }

  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;

    this.MinutoFaltandoIdle = 15;
    this.SegundoFaltandoIdle = 59;

    this.TempoFaltandoIdle = this.MinutoFaltandoIdle + ":" + this.SegundoFaltandoIdle;
  }
}
